// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityStyles } from "@steiner/Overrides/Components/ProductAvailability";
import AlertWarning from "@steiner/XDL/Icons/AlertWarning";
import Branch from "@steiner/XDL/Icons/Branch";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

productAvailabilityStyles.availabilityByWarehouseLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    icon: {
        iconProps: {
            src: Branch,
            size: 13,
            color: "primary",
            css: css`
                opacity: 0.66;
            `,
        },
    },
};

productAvailabilityStyles.messageText = {
    size: 12,
    lineHeight: "15px",
};

productAvailabilityStyles.container = {
    gap: 0,
    offsetCss: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 8px;
    `,
};
productAvailabilityStyles.inventoryMessage = {
    css: css`
        padding: initial;
        display: flex;
        align-items: flex-start;
        gap: 4px;
    `,
};
productAvailabilityStyles.availabilityByWarehouseModal = {
    sizeVariant: "small",
};

productAvailabilityStyles.errorWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 4px;
    `,
};

productAvailabilityStyles.errorText = {
    size: 12,
    lineHeight: "14px",
};

productAvailabilityStyles.nonStockTooltip = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        color: "text.link",
    },
    icon: {
        iconProps: {
            src: AlertWarning,
            color: "text.link",
            css: css`
                opacity: .66;
            `
        },
    },
    css: css`
        display: flex;
    `,
};

productAvailabilityStyles.notifyMessage = {
    css: css`
        margin-top: 16px;
        margin-bottom: 0;
    `,
};

productAvailabilityStyles.availabilityByWarehouseMessage = {
    forwardAs: "p",
    css: css`
        margin-bottom: 16px;
    `,
};